import React from 'react'
import Select from 'react-select'
import {preventDefaults} from 'survey-creator-react'

const normalizeSearchText = (value) =>
  (value ?? '')
    .toString()
    .trim()
    .toLocaleLowerCase('tr')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')

const nosiSelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 44,
    color: 'var(--nosi-text)',
    backgroundColor: 'var(--nosi-surface-muted)',
    borderColor: state.isFocused ? 'var(--nosi-accent)' : 'var(--nosi-border-strong)',
    borderRadius: '0.7rem',
    boxShadow: state.isFocused ? '0 0 0 0.22rem var(--nosi-focus-ring)' : 'none',
    transition: 'background-color 150ms ease, border-color 150ms ease, box-shadow 150ms ease',
    ':hover': {
      borderColor: 'var(--nosi-accent)',
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0.45rem 0.85rem',
  }),
  singleValue: (base) => ({
    ...base,
    color: 'var(--nosi-text)',
  }),
  input: (base) => ({
    ...base,
    color: 'var(--nosi-text-strong)',
  }),
  placeholder: (base) => ({
    ...base,
    color: 'var(--nosi-text-muted)',
  }),
  menu: (base) => ({
    ...base,
    zIndex: 1060,
    overflow: 'hidden',
    color: 'var(--nosi-text)',
    backgroundColor: 'var(--nosi-surface-elevated)',
    border: '1px solid var(--nosi-border)',
    borderRadius: '0.7rem',
    boxShadow: 'var(--nosi-shadow-md)',
  }),
  menuList: (base) => ({
    ...base,
    padding: '0.35rem',
  }),
  option: (base, state) => ({
    ...base,
    color: state.isSelected ? '#fff' : 'var(--nosi-text)',
    backgroundColor: state.isSelected
      ? 'var(--nosi-primary)'
      : state.isFocused
        ? 'var(--nosi-primary-soft)'
        : 'transparent',
    borderRadius: '0.5rem',
    cursor: 'pointer',
    ':active': {
      backgroundColor: state.isSelected ? 'var(--nosi-primary-hover)' : 'var(--nosi-primary-soft)',
    },
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: 'var(--nosi-primary-soft)',
    border: '1px solid var(--nosi-border)',
    borderRadius: '0.45rem',
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: 'var(--nosi-text-strong)',
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: 'var(--nosi-text-muted)',
    ':hover': {
      color: 'var(--nosi-danger-text)',
      backgroundColor: 'var(--nosi-danger-soft)',
    },
  }),
  indicatorSeparator: (base) => ({
    ...base,
    backgroundColor: 'var(--nosi-border-strong)',
  }),
  clearIndicator: (base) => ({
    ...base,
    color: 'var(--nosi-text-muted)',
    ':hover': {color: 'var(--nosi-danger-text)'},
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: 'var(--nosi-text-muted)',
    ':hover': {color: 'var(--nosi-accent)'},
  }),
  noOptionsMessage: (base) => ({
    ...base,
    color: 'var(--nosi-text-muted)',
  }),
  loadingMessage: (base) => ({
    ...base,
    color: 'var(--nosi-text-muted)',
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 1060,
  }),
}

const CustomSelect = (props) => {
  const handleMenuOpen = (event) => {
    event.stopPropagation()
    preventDefaults(event)
  }

  const defaultFilterOption = (option, rawInput) => {
    const normalizedInput = normalizeSearchText(rawInput)

    if (!normalizedInput) {
      return true
    }

    const normalizedLabel = normalizeSearchText(option?.label)
    const normalizedValue = normalizeSearchText(option?.value)
    const normalizedData = normalizeSearchText(option?.data?.label ?? option?.data?.value)

    return (
      normalizedLabel.includes(normalizedInput) ||
      normalizedValue.includes(normalizedInput) ||
      normalizedData.includes(normalizedInput)
    )
  }

  return (
    <Select
      {...props}
      classNamePrefix={props.classNamePrefix ?? 'nosi-select'}
      styles={{...nosiSelectStyles, ...(props.styles || {})}}
      filterOption={props.filterOption ?? defaultFilterOption}
      onMouseDown={(event) => {
        handleMenuOpen(event)
        if (props.onMenuOpen) {
          props.onMenuOpen(event)
        }
      }}
    />
  )
}

export default CustomSelect
